// Единая точка синхронизации полноэкранной рекламы.
// Фоновый шедулер (initAds) и цепочка Adsgram rewarded → interstitial (adsgramFlow)
// живут в разных модулях, но делят один экран, поэтому оба берут этот замок:
// без него два показа стартуют одновременно и гасят друг друга.

export type AdSlotRelease = (cooldownMs?: number) => void;

// Сеть может не вернуть управление из show() вообще: страховка, чтобы зависший
// показ не заблокировал экран для остальных источников навсегда.
const MAX_HOLD_MS = 120_000;

let busyOwner: string | null = null;
let quietUntil = 0;
let watchdog: number | undefined;

export function isAdSlotBusy(): boolean {
  return busyOwner !== null || Date.now() < quietUntil;
}

export function acquireAdSlot(owner: string): AdSlotRelease | null {
  if (isAdSlotBusy()) return null;
  busyOwner = owner;

  let released = false;
  const release: AdSlotRelease = (cooldownMs = 0) => {
    if (released) return;
    released = true;
    if (watchdog !== undefined) {
      window.clearTimeout(watchdog);
      watchdog = undefined;
    }
    busyOwner = null;
    quietUntil = Math.max(quietUntil, Date.now() + cooldownMs);
  };

  watchdog = window.setTimeout(() => {
    console.warn(`[AdSlot] forced release after ${MAX_HOLD_MS}ms, owner: ${owner}`);
    release();
  }, MAX_HOLD_MS);

  return release;
}

// Реклама, которую пользователь запустил сам, замок не занимает, но фоновые показы
// после неё должны выдержать паузу.
export function deferAdSlot(cooldownMs: number): void {
  quietUntil = Math.max(quietUntil, Date.now() + cooldownMs);
}
